/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import { TSO }          from '@/models/scenario/t.s.o';
import {TSOSpeed}       from '@/models/scenario/t.s.o.speed';
import {DecisionPoint}  from '@/models/scenario/decision.point';
import {TSOLink} from "@/models/scenario/t.s.o.link";
import {TrainClass} from "@/models/scenario/train.class";
import {Period} from "@/util/period";

/**
 *
 * @class TSOChange
 *
 * @brief basic interface for working with the selected slow order between the
 * various parts of the tso editor. We don't use an actual tso, because the selection
 * may also be used for adding or editing a row (a tso). That is, we need a change carrier.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class TSOChange {

  /** the object that caused the selection or edit of this tso */
  public            src: any            = null;

  /** the unique ID for this tso, at least among slow orders */
  public             id: number         = -1;

  /** user label for tso */
  public           name: string         = '';

  /** user description of work */
  public    description: string        = ';';

  /** the start of the slow order (seconds) */
  public          start: Period        = new Period('P00DT00H00M00S');

  /** how long it is (seconds) */
  public       duration: Period        = new Period('P00DT00H00M00S');

  /** the release tonnage */
  public        tonnage: number        = 0;

  /** the (maybe in between) mileage on east side */
  public       eastMile: number        = 0;

  /** the east side decision point */
  public         eastDP: DecisionPoint = null;

  /* the maybe in between) mileage on west side */
  public       westMile: number        = 0;

  /** the west side decision point */
  public         westDP: DecisionPoint = null;

  /** the freight speed */
  public       frtSpeed: number        = 0;

  /** the passenger speed */
  public       psgSpeed: number        = 0;

  /* train classes for freight trains */
  public     frtClasses: TrainClass[]  = [];

  /* train classes for passenger trains */
  public     psgClasses: TrainClass[]  = [];

  /** the actual TSO model (for add/clone/delete) */
  public          model: TSO           = null;

  /**
   *
   * some changes have to be paired with the current state of the editing panel;
   * this allows us to rollback to states where the editor has transient data; not
   * yet saved to an actual row.
   *
   */
  public       snapshot: TSOChange     = null;

  /** standard constructor, allow anonymous object initialization */
  public constructor(init?: Partial<TSOChange>) {

    Object.assign(this, init);
  }
}
